import React, { useState, useEffect } from 'react';
import { TextField, Label, Button, shapes } from '@cimpress/react-components';
import { useModal } from '../../../contexts/modal-context';
import TemplateForm from '../../../components/TemplateForm';
import ListGroup, { ListGroupItem } from '../../../components/ListGroup';
import { useSelector, useDispatch } from 'react-redux';
import { Template, compareTemplates } from '../../../models/truck';
import { getTruckTemplates } from '../../../store/actions/truck-template';
import { getLoadingRestrictions } from '../../../store/actions/loading-restriction';
import { LoadingRestrictionState } from '../../../store/state/loading-restriction';
import { getLinehaulCompanies } from '../../../store/actions/linehaul-company';
import TruckTemplateState from '../../../store/state/TruckTemplateState';
import { getCustomsBrokers } from '../../../store/actions/customs-broker';

// tslint:disable-next-line:import-name
import settingsStyle from '../index.module.css';

// tslint:disable-next-line:import-name
import style from './index.module.css';
import { StoreState } from '../../../store/state';
import { CustomsBrokerState } from '../../../store/state/customs-broker';

const loadingRestrictionColor: { [k: string]: 'danger' | 'default' | 'info' | 'primary' | 'success' | 'warning'; } = {
  'ShipmentQualifierTruckLoadingRestriction::tariff-category': 'success',
  'ShipmentQualifierTruckLoadingRestriction::carrier-account': 'info',
};

export default () => {
  const modal = useModal();
  const [search, setSearch] = useState('');
  const dispatch = useDispatch();
  const templateState = useSelector<StoreState, TruckTemplateState>(state => state.truckTemplate);
  const loadingRestrictions = useSelector<StoreState, LoadingRestrictionState['all']>(state => state.loadingRestrictions ? state.loadingRestrictions.all : {});
  const customsBrokers = useSelector<StoreState, CustomsBrokerState['all']>(state => state.customsBrokers ? state.customsBrokers.all : {});

  const [displayedTemplates, setDisplayedTemplates] = useState<Template[]>([]);

  useEffect(
    () => {
      dispatch(getLoadingRestrictions.request());
      dispatch(getTruckTemplates.request());
      dispatch(getLinehaulCompanies.request());
      dispatch(getCustomsBrokers.request());
    },
    [],
  );

  useEffect(
    () => {
      setDisplayedTemplates(
        templateState.templates
          .filter(template =>
            search.length === 0
            || template.name.search(new RegExp(search, 'i')) !== -1
            || (template.truckName && template.truckName.search(new RegExp(search, 'i')) !== -1)
            || template.loadingRestrictions.findIndex(
              restriction =>
                loadingRestrictions[restriction.restrictionType][restriction.value].displayValue.search(new RegExp(search, 'i')) !== -1,
            ) !== -1,
          )
          .sort(compareTemplates),
      );
    },
    [templateState, search, loadingRestrictions],
  );

  const content = () => {
    if (templateState.templates.length === 0) {
      return <h6>
        Create your first template.
      </h6>;
    }

    if (displayedTemplates.length === 0) {
      return <h6>
        No templates found matching your search.
      </h6>;
    }

    return <ListGroup className={style.TemplateList}>
      {displayedTemplates
        .map(template =>
          <ListGroupItem key={template.name}>
            <button className={style.TemplateButton} onClick={() => modal('Edit Truck Template', hide => <TemplateForm close={hide} template={template} />, { bsStyle: 'info' })}>
              <div className={settingsStyle.Template}>
                <h5>{template.name}</h5>
                <div>
                  <p><span>Truck name:</span> {template.truckName}</p>
                  {
                    template.loadingRestrictions
                      .filter(restriction =>
                        loadingRestrictions[restriction.restrictionType]
                        && loadingRestrictions[restriction.restrictionType][restriction.value],
                      )
                      .map(restriction =>
                        <Label
                          text={loadingRestrictions[restriction.restrictionType][restriction.value].displayValue}
                          type={loadingRestrictionColor[restriction.restrictionType]}
                          key={loadingRestrictions[restriction.restrictionType][restriction.value].value}
                        />,
                      )
                  }
                  {
                    template.customsBrokerId && template.customsBrokerId in customsBrokers && <Label text={customsBrokers[template.customsBrokerId].name} type="danger" />
                  }
                </div>
              </div>
            </button>
          </ListGroupItem>,
        )
      }
    </ListGroup>;
  };

  return <>
    <div>
      <h3>Truck Templates <Label text={`${displayedTemplates.length}`} /></h3>
      <Button
        type="primary"
        onClick={() => modal('Create Template', hide => <TemplateForm close={hide} />, { bsStyle: 'info' })}
      >
        <i className="fa fa-plus" /> Create Template
      </Button>
    </div>
    <TextField
      label="Search"
      value={search}
      onChange={e => setSearch(e.target.value)}
    />
    <div>
      {
        templateState.loading
        ? <shapes.Spinner />
        : content()
      }
    </div>
  </>;
};
